import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import amelioLogo from '@/assets/logo/amelio-logo.png';
interface HandoutEmployeeInfoProps {
    employeeName: string;
    employeeRole: string;
    employeeProfile: string;
    employeeAvatarUrl?: string;
}

export const HandoutEmployeeInfo = ({
    employeeName,
    employeeRole,
    employeeProfile,
    employeeAvatarUrl,
}: HandoutEmployeeInfoProps) => {
    const { t } = useTranslation();
    const [avatarFailed, setAvatarFailed] = useState(false);
    const initials = employeeName
        .split(' ')
        .filter(Boolean)
        .map((name) => name[0])
        .join('');

    const profileFull = t('postReviewPrepareMeeting.handout.employeeProfile', {
        profile: employeeProfile,
    });
    const colonIndex = profileFull.indexOf(':');
    const profileLabel =
        colonIndex >= 0 ? profileFull.slice(0, colonIndex + 1).trimEnd() : profileFull;
    const profileValue = colonIndex >= 0 ? profileFull.slice(colonIndex + 1).trim() : '';

    return (
        <div
            className={
                'mb-3 flex flex-col gap-[16px] border-b border-[#e2e8f0] pb-[16px] sm:mb-6 sm:flex-row sm:items-center sm:justify-between'
            }
        >
            <div className={'flex items-center gap-[12px]'}>
                <div
                    className={
                        'flex h-[64px] w-[64px] items-center justify-center rounded-[8px] bg-white shadow-md'
                    }
                >
                    {employeeAvatarUrl && !avatarFailed ? (
                        <img
                            className={'h-[60px] w-[60px] rounded-full object-cover'}
                            alt={employeeName}
                            src={employeeAvatarUrl}
                            onError={() => setAvatarFailed(true)}
                        />
                    ) : (
                        <div
                            className={
                                'flex h-[56px] w-[56px] items-center justify-center rounded-full border border-teal-100 bg-teal-50 text-2xl font-bold text-teal-700'
                            }
                        >
                            {initials}
                        </div>
                    )}
                </div>
                <div className={'flex flex-col gap-[4px]'}>
                    <h2 className={'text-subtitle! text-navy font-bold'}>{employeeName}</h2>
                    <p className={'text-caption! text-gray-500'}>{employeeRole}</p>
                    <p className={'text-caption! font-semibold'}>
                        <span className={'text-gray-500'}>{profileLabel}</span>
                        {profileValue && (
                            <span className={'ms-1 text-[var(--color-primary-500)]'}>
                                {profileValue}
                            </span>
                        )}
                    </p>
                </div>
            </div>
            <div className={'flex items-center self-center sm:self-auto'}>
                <img
                    alt={'Amelio'}
                    className={'w-56 flex-shrink-0 object-contain'}
                    src={amelioLogo}
                />
            </div>
        </div>
    );
};
